/**
 * Bevestiging in de pagina, voor de telefoon (19-10-2026, Jordy: "op mobiel kan
 * een chatter een bericht niet verwijderen").
 *
 * Op desktop vraagt het chatvenster met `window.confirm`. Die dialoog is van de
 * browser zelf, en op een telefoon wordt hij stil overgeslagen (dan geeft hij
 * meteen "Annuleren" terug) in een ingebouwde browser, bv. een link uit Telegram
 * of WhatsApp, of nadat iemand eerder "geen dialoogvensters meer" heeft
 * aangetikt. De actie gebeurde dan nooit, zonder melding. Deze bevestiging is
 * gewoon een stuk pagina en werkt overal. Alleen gerenderd onder 900px (lib/mobiel).
 */
import { useEffect, useRef } from 'react'

export function MobielBevestig({
  tekst,
  ja = 'OK',
  nee = 'Cancel',
  gevaar = false,
  onJa,
  onNee,
}: {
  tekst: string
  ja?: string
  nee?: string
  /** Rode bevestigknop: de actie is onomkeerbaar. */
  gevaar?: boolean
  onJa: () => void
  onNee: () => void
}) {
  const neeKnop = useRef<HTMLButtonElement>(null)
  // De focus op Annuleren: per ongeluk Enter of een tweede tik verwijdert niets.
  useEffect(() => { neeKnop.current?.focus() }, [])
  return (
    <div className="mbevestig-sluier" onClick={onNee}>
      <div className="mbevestig" role="alertdialog" aria-modal="true" aria-label={tekst}
           onClick={(e) => e.stopPropagation()}>
        <p>{tekst}</p>
        <div className="mbevestig-knoppen">
          <button ref={neeKnop} type="button" className="btn ghost" onClick={onNee}>{nee}</button>
          <button type="button" className={gevaar ? 'btn mbevestig-gevaar' : 'btn'}
                  data-testid="bevestig-ja" onClick={onJa}>{ja}</button>
        </div>
      </div>
    </div>
  )
}
